// extracted by mini-css-extract-plugin
module.exports = {"page":"style-module__page___3E9v7","pageCard":"style-module__pageCard___1CRxb"};